export default __webpack_public_path__ + "static/media/man1.23522e09.svg";